import React, { useState, useEffect } from 'react';
import Login from './componentes/Login';
import GestionPedidos from './componentes/GestionPedidos';
import GestionCombustible from './componentes/GestionCombustible';
import GestionFletes from './componentes/GestionFletes';
import DashboardGerente from './componentes/DashboardGerente';
import DashboardEmpleado from './componentes/DashboardEmpleado';
import DashboardCajas from './componentes/DashboardCajas';
import FormularioAutos from './componentes/FormularioAutos';
import GestionMantenimiento from './componentes/GestionMantenimiento';
import GestionAlertas from './componentes/GestionAlertas';
import { PedidosService } from './services/pedidosService';
import { FiPackage, FiDroplet, FiTruck, FiTool, FiLogOut, FiMenu, FiBell, FiMapPin } from 'react-icons/fi';
import './App.css';

// Componente para mostrar badge de alertas en el menú
const AlertasBadge = () => {
  const [numAlertas, setNumAlertas] = useState(0);

  useEffect(() => {
    const unsubscribePedidos = PedidosService.suscribirsePedidos((pedidos) => {
      const ahora = new Date();
      const alertas = pedidos.filter(pedido => {
        // Excluir pedidos que ya están entregados
        if (pedido.estatus === 'entregado') {
          return false;
        }

        const fechaActualizacion = pedido.fechaActualizacion 
          ? new Date(pedido.fechaActualizacion).getTime()
          : pedido.timestamp 
            ? pedido.timestamp
            : pedido.fechaCompra 
              ? new Date(pedido.fechaCompra).getTime()
              : null;

        if (!fechaActualizacion) return false;
        const horasSinActualizar = (ahora.getTime() - fechaActualizacion) / (1000 * 60 * 60);
        return horasSinActualizar >= 24;
      });
      setNumAlertas(alertas.length);
    });

    return () => {
      unsubscribePedidos();
    };
  }, []);

  if (numAlertas === 0) return null;

  return (
    <span className="alertas-badge">
      {numAlertas}
    </span>
  );
};

function App() {
  const [vistaActual, setVistaActual] = useState('pedidos');
  const [usuario, setUsuario] = useState(null);
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    // Limpiar localStorage al inicio para evitar datos corruptos
    localStorage.removeItem('usuario');
    setCargando(false);
  }, []);

  const handleCerrarSesion = () => {
    localStorage.removeItem('usuario');
    setUsuario(null);
  };

  const handleLoginSuccess = (rol, nombre) => {
    setUsuario({ rol, nombre });
  };

  if (cargando) {
    return (
      <div className="loading-container">
        <div className="loading-spinner">
          <div className="spinner"></div>
          <p>Cargando...</p>
        </div>
      </div>
    );
  }

  if (!usuario) {
    return <Login onLoginSuccess={handleLoginSuccess} />;
  }

  // Renderizar dashboard según el rol del usuario
  const renderDashboard = () => {
    console.log('Usuario actual:', usuario);
    console.log('Rol del usuario:', usuario?.rol);
    
    if (!usuario || !usuario.rol) {
      console.log('No hay usuario o rol, mostrando login');
      return <Login onLoginSuccess={handleLoginSuccess} />;
    }

    switch (usuario.rol) {
      case 'gerente':
        return <DashboardGerente />;
      case 'empleado':
        return <DashboardEmpleado />;
      case 'cajas':
        return <DashboardCajas />;
      case 'logistica':
        return (
          <div className="App modern-dashboard">
            <aside className="sidebar-modern">
              <div className="sidebar-header">
                <div className="logo-modern">
                  <div className="logo-icon-modern">L</div>
                  <span className="logo-text-modern">Logística</span>
                </div>
              </div>
              <nav className="nav-menu-modern">
                <div className="nav-section">
                  <div className="nav-section-title">MENU</div>
                  <button 
                    className={`nav-item-modern ${vistaActual === 'pedidos' ? 'active' : ''}`}
                    onClick={() => setVistaActual('pedidos')}
                  >
                    <FiPackage className="nav-icon-modern" />
                    <span>Gestión de Pedidos</span>
                  </button>
                  <button 
                    className={`nav-item-modern ${vistaActual === 'combustible' ? 'active' : ''}`}
                    onClick={() => setVistaActual('combustible')}
                  >
                    <FiDroplet className="nav-icon-modern" />
                    <span>Gestión de Combustible</span>
                  </button>
                  <button 
                    className={`nav-item-modern ${vistaActual === 'fletes' ? 'active' : ''}`}
                    onClick={() => setVistaActual('fletes')}
                  >
                    <FiMapPin className="nav-icon-modern" />
                    <span>Gestión de Fletes</span>
                  </button>
                  <button 
                    className={`nav-item-modern ${vistaActual === 'autos' ? 'active' : ''}`}
                    onClick={() => setVistaActual('autos')}
                  >
                    <FiTruck className="nav-icon-modern" />
                    <span>Gestión de Autos</span>
                  </button>
                  <button 
                    className={`nav-item-modern ${vistaActual === 'mantenimiento' ? 'active' : ''}`}
                    onClick={() => setVistaActual('mantenimiento')}
                  >
                    <FiTool className="nav-icon-modern" />
                    <span>Mantenimiento</span>
                  </button>
                  <button 
                    className={`nav-item-modern ${vistaActual === 'alertas' ? 'active' : ''}`}
                    onClick={() => setVistaActual('alertas')}
                  >
                    <FiBell className="nav-icon-modern" />
                    <span>Gestión de Alertas</span>
                    <AlertasBadge />
                  </button>
                </div>
                <div className="nav-section-bottom">
                  <button 
                    className="nav-item-modern cerrar-sesion-modern"
                    onClick={handleCerrarSesion}
                    title="Cerrar Sesión"
                  >
                    <FiLogOut className="nav-icon-modern" />
                    <span>Cerrar Sesión</span>
                  </button>
                </div>
              </nav>
            </aside>
            <main className="main-content-modern">
              {vistaActual === 'pedidos' && <GestionPedidos />}
              {vistaActual === 'combustible' && <GestionCombustible />}
              {vistaActual === 'fletes' && <GestionFletes />}
              {vistaActual === 'autos' && <FormularioAutos />}
              {vistaActual === 'mantenimiento' && <GestionMantenimiento />}
              {vistaActual === 'alertas' && <GestionAlertas />}
            </main>
          </div>
        );
      case 'mostrador':
        return (
          <div className="App">
            <nav className="navbar">
              <div className="nav-brand">
                <h1>Sistema de Gestión - Mostrador</h1>
              </div>
              <div className="nav-menu">
                <button 
                  className={`nav-item ${vistaActual === 'pedidos' ? 'active' : ''}`}
                  onClick={() => setVistaActual('pedidos')}
                >
                  Gestión de Pedidos
                </button>
                <button 
                  className="nav-item cerrar-sesion"
                  onClick={handleCerrarSesion}
                  title="Cerrar Sesión"
                >
                  Cerrar Sesión
                </button>
              </div>
            </nav>
            <main className="main-content">
              {vistaActual === 'pedidos' && <GestionPedidos />}
            </main>
          </div>
        );
      default:
        console.log('Rol no reconocido:', usuario.rol);
        return (
          <div>
            <p>Rol no reconocido: {usuario.rol}</p>
            <button onClick={handleCerrarSesion}>Cerrar Sesión</button>
          </div>
        );
    }
  };

  return renderDashboard();
}

export default App;